module.exports = __webpack_public_path__ + "img/mic.9823ec3c.png";